import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ChecklistItem {
  id: string;
  checklistTemplateId: string;
  question: string;
  displayOrder: number;
  isActive: boolean;
}

export interface ChecklistTemplate {
  id: string;
  name: string;
  isActive: boolean;
  itemCount: number;
  items: ChecklistItem[];
}

export interface CreateChecklistTemplateDto {
  name: string;
}

export interface UpdateChecklistTemplateDto {
  name: string;
  isActive: boolean;
}

export interface CreateChecklistItemDto {
  question: string;
  displayOrder: number;
}

export interface UpdateChecklistItemDto {
  question: string;
  displayOrder: number;
  isActive: boolean;
}

@Injectable({ providedIn: 'root' })
export class ChecklistTemplateService {
  private apiUrl = `${environment.apiUrl}/ChecklistTemplate`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<ChecklistTemplate[]> {
    return this.http.get<ChecklistTemplate[]>(this.apiUrl);
  }

  getActive(): Observable<ChecklistTemplate[]> {
    return this.http.get<ChecklistTemplate[]>(`${this.apiUrl}/active`);
  }

  getById(id: string): Observable<ChecklistTemplate> {
    return this.http.get<ChecklistTemplate>(`${this.apiUrl}/${id}`);
  }

  create(dto: CreateChecklistTemplateDto): Observable<ChecklistTemplate> {
    return this.http.post<ChecklistTemplate>(this.apiUrl, dto);
  }

  update(id: string, dto: UpdateChecklistTemplateDto): Observable<ChecklistTemplate> {
    return this.http.put<ChecklistTemplate>(`${this.apiUrl}/${id}`, dto);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  addItem(templateId: string, dto: CreateChecklistItemDto): Observable<ChecklistItem> {
    return this.http.post<ChecklistItem>(`${this.apiUrl}/${templateId}/items`, dto);
  }

  updateItem(templateId: string, itemId: string, dto: UpdateChecklistItemDto): Observable<ChecklistItem> {
    return this.http.put<ChecklistItem>(`${this.apiUrl}/${templateId}/items/${itemId}`, dto);
  }

  deleteItem(templateId: string, itemId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${templateId}/items/${itemId}`);
  }
}
